<template>
  <div>
    <DynamicComponent edc-id="polaris-operate-manage" framework="Vue" :edc-dev="edcDev" />
  </div>
</template>

<script>
export default {
  name: 'polarisOperateManage',
  data() {
    return {
      edcDev: window.__EDC__.options.dev,
    }
  },
}
</script>
